import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import styled from 'foundations-theming/utils';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { STANDALONE_CORE_SEATS } from '../../constants/ReleaseInsights';
import { NavItemEnum, SegmentedNavItems } from '../../constants/routing/NavItems';
import { useHasReleaseInsight } from '../../hooks/useBulkPurchaseOptions';
import { isUngatedForBreezeIntelligenceSelector, isUngatedForMarketingPlusSelector } from '../../selectors/GatingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileDropdownNavLabel = styled(UIFormControl).withConfig({
  displayName: "MobileDropdownNav__MobileDropdownNavLabel",
  componentId: "sc-7iy5u3-0"
})(["width:94%;margin:0 auto;"]);
const MobileDropdownNav = ({
  selectedNavItem
}) => {
  const history = useHistory();
  const [currNavItem, selectCurrNavItem] = useState(selectedNavItem);
  const isUngatedToMarketingPlus = useSelector(isUngatedForMarketingPlusSelector);
  const isUngatedForBreezeIntelligence = useSelector(isUngatedForBreezeIntelligenceSelector);
  const {
    hasReleaseInsight: isSmartCrm,
    loading: isLoadingSmartCrm
  } = useHasReleaseInsight({
    releaseInsight: STANDALONE_CORE_SEATS
  });
  const navItems = SegmentedNavItems;
  const shouldHideNavItem = item => {
    return item === NavItemEnum.MARKETING_PLUS && !isUngatedToMarketingPlus || item === NavItemEnum.ADD_ONS ||
    // not available on mobile or public
    item === NavItemEnum.BREEZE_INTELLIGENCE && !isUngatedForBreezeIntelligence || item === NavItemEnum.RECOMMENDED ||
    // not available on mobile or public
    item === NavItemEnum.SMART_CRM && (!isSmartCrm || isLoadingSmartCrm) // don't show smart crm link if not ungated
    ;
  };
  const navItemOptions = Object.values(navItems).flat().filter(navItem => !shouldHideNavItem(navItem)).map(navItem => {
    const key = `pricingPage.pages.products.tabs.${navItem}.tabTitle`;
    return {
      text: I18n.text(key),
      value: navItem
    };
  });
  const handleChange = evt => {
    evt.preventDefault();
    const newNavItem = evt.currentTarget.value;
    selectCurrNavItem(newNavItem);
    history.push(`/${newNavItem}`);
  };
  return /*#__PURE__*/_jsx(MobileDropdownNavLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.tabs.pricingAndPlans"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      searchable: false,
      options: navItemOptions,
      onChange: handleChange,
      value: currNavItem
    })
  });
};
export default MobileDropdownNav;